<nav class="navbar navbar-expand-lg navbar-light nav-header navbar-fixed">
    <div class="container nav-container">
        <a class="navbar-brand" href="">
            <img src="/assets/img/logo-v1.svg" />
        </a>
        <button class="navbar-toggler collapsed" type="button" aria-controls="navbarSupportedContent"
            aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
    </div>
</nav>